<script setup lang="ts">
const width1 = 75 + Math.random() * 25
const width2 = 25 + Math.random() * 50
</script>

<template>
  <os-column cross-axis-alignment="start">
    <ion-skeleton-text
      :animated="true"
      :style="`width: ${width1}%; height: 17px`"
    />
    <ion-skeleton-text
      :animated="true"
      :style="`width: ${width2}%; height: 17px`"
    />
  </os-column>
</template>
